var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('navbar'),_c('app-main'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }